import { Component } from '@angular/core';

@Component({
    selector: 'app-text-img-2',
    templateUrl: './text-img-2.component.html',
    styleUrls: ['./text-img-2.component.scss']
})
export class TextImg2Component {}
